import { createStore } from 'vuex'

export default createStore({
  state: {
    DataForCheckIns:{},
    DataForWorkHistory:[],
    FilterUsersManagementPage:{ Role: 14, Active: 1 ,Mode:-2},
    FilterClassManagement:{ ChartId: -1, Sex: -1, IsActive: 1 },
    sidebarOpen:true,
  },
  getters: {
    GetDataForCheckIns(state){
      return state.DataForCheckIns
    },
    GetDataForWorkHistory(state){
      return state.DataForWorkHistory
    },
  },
  mutations: {
    SetDataCheckIns(state,payload){
      state.DataForCheckIns=payload
    },
    SetDataWorkHistory(state,payload){
      state.DataForWorkHistory=payload
    },
  },
  actions: {
    UpdateDataCheckIns({commit}, DataForCheckIns){
      commit('SetDataCheckIns',DataForCheckIns)
    },
    UpdateDataWorkHistory({commit}, DataForWorkHistory){
      commit('SetDataWorkHistory',DataForWorkHistory)
    },
  },
  modules: {
  }
})
